import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { Loader2, MessageSquare } from "lucide-react";

export default function SiteAgentTranscript({ wsId, leadId }: { wsId: number | null; leadId: number }) {
  const { data: convs = [], isLoading } = useQuery<any[]>({
    queryKey: ["/api/workspaces", wsId, "site-conversations", "lead", leadId],
    queryFn: () => apiRequest("GET", `/api/workspaces/${wsId}/site-conversations/by-lead/${leadId}`).then(r => r.json()),
    enabled: !!wsId && !!leadId,
  });

  if (!wsId) return null;
  if (isLoading) return (
    <div className="bg-card/50 border border-emerald-500/20 rounded-2xl p-4" data-testid="site-agent-transcript-loading">
      <div className="h-3 w-32 bg-muted/50 animate-pulse rounded" />
    </div>
  );

  const allMsgs = convs.flatMap((c: any) => (c.messages || []).map((m: any) => ({ ...m, pageUrl: c.pageUrl })));

  return (
    <div className="bg-card/50 border border-emerald-500/20 rounded-2xl p-4 space-y-3" data-testid="site-agent-transcript">
      <h3 className="text-xs font-bold text-emerald-400 uppercase tracking-wider flex items-center gap-2">
        <MessageSquare size={12} />
        Widget Conversation {convs.length > 1 && <span className="text-muted-foreground/50 font-normal">({convs.length} sessions)</span>}
      </h3>
      {allMsgs.length > 0 ? (
        <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
          {allMsgs.map((m: any, i: number) => (
            <div key={i} className={`flex gap-2 ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[82%] rounded-xl px-3 py-2 text-xs ${
                m.role === "user"
                  ? "bg-emerald-600/20 text-emerald-200 border border-emerald-500/20"
                  : "bg-muted/60 text-foreground/80 border border-border"
              }`}>
                {m.text}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground/50">No transcript yet.</p>
      )}
      {convs[0]?.pageUrl && (
        <p className="text-[10px] text-muted-foreground/40 truncate">From: {convs[0].pageUrl}</p>
      )}
    </div>
  );
}
